import { Routes, Route } from "react-router-dom";
import AppShell from "./AppShell";
import LoginView from "./views/auth/LoginView";
import AuthCallback from "./views/auth/AuthCallback";
import AdminView from "./views/admin/AdminView";
import { ProtectedRoute, AdminRoute } from "./components/ProtectedRoute";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginView />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route
        path="/admin"
        element={
          <AdminRoute>
            <AdminView />
          </AdminRoute>
        }
      />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <AppShell />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}
